/* eslint-disable react-hooks/exhaustive-deps */
import AboutUs from '@/components/AboutUs';
import {
  DatePickerCustom,
  TimePickerCustom,
} from '@/components/DateTimeCustom';
import ErrorSubmitBar from '@/components/ErrorSubmitBar';
import InputAutocompleteClass from '@/components/InputAutocompleteClass';
import InputCustom from '@/components/InputCustom';
import MapDialog from '@/components/MapDialog';
import PaymentBar from '@/components/PaymentBar';
import PreLoading from '@/components/PreLoading';
import {
  CallCallingIcon,
  DirectUpIcon,
  LocationIcon,
  TicketDiscountIcon,
  UserIcon,
  UserSquareIcon,
} from '@/components/SvgIcons';
import useBooking from '@/hooks/useBooking';
import { bookingService } from '@/services/bookingService';
import useStoreApp from '@/store';
import {
  BookingType,
  ContactNumberType,
  MessengerType,
  OrderType,
  SourceType,
} from '@/types/consistency';
import { IBookingForm, IDialCode } from '@/types/interface';
import { bookingScheme } from '@/types/schema';
import { formatNumber } from '@/utils/handleFormatNumber';
import { yupResolver } from '@hookform/resolvers/yup';
import MapIcon from '@mui/icons-material/Map';
import {
  Box,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import parsePhoneNumber from 'libphonenumber-js';
import moment from 'moment';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import {
  BookingContainer,
  BookingDateTime,
  BookingForm,
  BookingNumberOfPeople,
  BookingPersonalInformation,
  BookingTripInformation,
  StyledSelectDialCode,
} from './style';
import { formatDateRequest, formatTimeDisplay, pushToBookingDetail, pushToPublicHistory } from '@/utils/utils';
import BookingFormSelect from '@/components/BookingFormCustom/BookingFormSelect';
import TextFieldCustom from '@/components/TextFieldCustom';

export default function BookingByCustomer() {
  const { t } = useTranslation(['validate', 'common', 'error']);

  const router = useRouter();
  const theme = useTheme();

  const { language_id } = router.query as { language_id?: string };

  const { languageId, dialCodes, isEmbeed } = useStoreApp(state => state.globalSlice);
  const [typeMap, setTypeMap] = useState<'' | 'pickUp' | 'dropOff'>('');
  const [pickUpMapValue, setPickUpMapValue] = useState<string | null>(
    router.query.address as string | null,
  );
  const [dropOffMapValue, setDropOffMapValue] = useState<string | null>(null);
  const [collaboratorId] = useState<string | null>(
    router.query.collaboratorId as string | null,
  );

  const [showDialCode, setShowDialCode] = useState<boolean>(false);

  const [promotionName] = useState<string | null>(
    router.query.promotionName as string | null,
  );

  const schema = useMemo(() => yup.object().shape({
    ...bookingScheme,
    phone: yup
      .string()
      .trim()
      .nullable()
      .test('isValidPhone', 'invalidPhone', (value: any, ctx: any) => {
        let parsedPhone = undefined;
        if (value) {
          parsedPhone = parsePhoneNumber(value, ctx.parent.dialCode);
        }
        return (
          !value ||
          (parsedPhone &&
            parsedPhone.isValid() &&
            parsedPhone.country === ctx.parent.dialCode)
        );
      })
  }), [])
    .test('isContactInfoValid', 'contactInfoInvalid', function (value: any) {


      const { contactNumber, zalo, whatsapp, kakaotalk, viber } = value;

      const isContactInfoValid = Boolean(contactNumber || zalo || whatsapp || kakaotalk || viber);

      if (isContactInfoValid) {
        clearErrors(["contactNumber"]);
        return true;
      }

      const errors = [
        this.createError({ path: 'contactNumber', message: 'required' })
      ];
      return new yup.ValidationError(errors);
    });

  const {
    trigger,
    clearErrors,
    setValue,
    setError,
    watch,
    handleSubmit,
    register,
    formState: { errors, isDirty, isValid, isSubmitting },
  } = useForm<IBookingForm>({
    mode: 'all',
    resolver: yupResolver(schema),
  });

  const {
    pickUpData,
    setPickUpData,
    dropOffData,
    setDropOffData,
    promotion,
    setPromotion,
    errorPromotion,
    setErrorPromotion,
    // distanceInformation,
    isChangedTimer,
    setIsChangedTimer,
    date,
    setDate,
    dateErrMsg,
    time,
    setTime,
    timeErrMsg,
    successBooking,
    bookingErrMsg,
    errorPrice,
    bookingDone,
    loading,
    // realMoney,
    isCurrentDate,
    setDateTimeErrMsg,
    handlePromotion,
    handlePhoneNumber,
    doSubmit,
    checkPickUpAndDropOff,
    // handleDistanceInformation,
    DURATION_WAITING_BOOKING_TAXI,
    computePrice,
    computedPricing,
    contactNumberTypeOptions,
  } = useBooking(bookingService);

  const checkKeyDown = useCallback((e: any) => {
    if (e.key === 'Enter') e.preventDefault();
  }, []);

  useEffect(() => {
    if (router.query.address && router.query.lat && router.query.lng) {
      setPickUpData({
        pickUp: JSON.stringify({
          lat: Number(router.query.lat),
          lng: Number(router.query.lng),
        }),
        pickUpAddress: router.query.address as string,
      });
    }
  }, []);

  useEffect(() => {
    if (promotionName !== undefined && promotionName !== null && promotionName !== '' && collaboratorId !== null && collaboratorId !== '') {
      handlePromotion(promotionName, collaboratorId);
    }
  }, [promotionName, collaboratorId]);

  const tel = useMemo(() => {
    if (watch('phone') && watch('dialCode')) {
      return parsePhoneNumber(watch('phone'), watch('dialCode'))?.number;
    }
    return undefined;
  }, [watch('phone'), watch('dialCode')]);

  const countryCode = useMemo(() => {
    if (dialCodes.length <= 0) return undefined;
    return dialCodes.find((e: IDialCode) => e.code === watch('dialCode'));
  }, [watch('dialCode'), dialCodes.length]);

  const onInvalidSubmit = useCallback((errors: any) => {
    console.group('customer -> onInvalidSubmit -> errors');
    console.log('errors:', errors);
    console.groupEnd();
  }, []);

  const onSubmit = useCallback(
    (formData: IBookingForm) => {
      console.group('customer -> onSubmit -> formData');
      console.log('formData:', formData);
      console.groupEnd();

      // handle time from time, date inputs and check validation
      if (dateErrMsg || timeErrMsg) return;

      if (Boolean(errorPromotion)) return;

      if (Boolean(errorPrice)) return;

      if (!pickUpData || !dropOffData) return;

      const parseTime = time.format(formatTimeDisplay);
      const parseDate = date.format(formatDateRequest);
      let type = OrderType.Now.code;

      // Create datetime strings in a consistent format
      const selectedDateTime = moment(`${parseDate} ${parseTime}`, 'YYYY-MM-DD HH:mm');
      const currentDateTime = moment();
      const timeDifferenceMinutes = selectedDateTime.diff(currentDateTime, 'minutes');

      let scheduleDate: Date = new Date(`${parseDate}T${parseTime}:00`);

      if (isChangedTimer && timeDifferenceMinutes >= DURATION_WAITING_BOOKING_TAXI) {
        type = OrderType.Timer.code;
      } else {
        scheduleDate = new Date();
      }

      const isMultiETaxi = Number(formData.adults) > 8;
      // ||
      // Number(formData.adults) + Number(formData.children) / 2 > 9;

      let contactInfoData = {
        phone: '',
        email: formData.email ?? '',
        zalo: '',
        whatsapp: '',
        kakaotalk: '',
        viber: ''
      };

      switch (formData.contactNumberType) {
        case 'phone':
          contactInfoData.phone = formData.contactNumber ?? '';
          break;

        case 'zalo':
          contactInfoData.zalo = formData.contactNumber ?? '';
          break;

        case 'whatsapp':
          contactInfoData.whatsapp = formData.contactNumber ?? '';
          break;

        case 'kakaotalk':
          contactInfoData.kakaotalk = formData.contactNumber ?? '';
          break;

        case 'viber':
          contactInfoData.viber = formData.contactNumber ?? '';
          break;

        default:
          contactInfoData.phone = formData.contactNumber ?? '';
          break;
      }

      let sourceType = SourceType.Customer.code;
      let bookingType = BookingType.WebCustomer.code;

      if (collaboratorId !== null && collaboratorId !== '') {
        sourceType = SourceType.Partner.code;
        bookingType = BookingType.PartnerQR.code;
      }

      let body = {
        isPaymentMerge: isMultiETaxi ? true : false,
        dialCode: countryCode?.dialCode,
        //phone: parsePhoneNumber(formData.phone, formData.dialCode)
        //  ?.nationalNumber,
        passengerName: formData.fullName,
        passengerNormal: Number(formData.adults),
        // passengerHalf: Number(formData.children) ?? 0,
        distanceKm: computedPricing?.distance,
        ...pickUpData,
        ...dropOffData,
        price: computedPricing?.price,
        money: computedPricing?.money,
        orderType: type,
        scheduleDate,
        description: formData.description,
        languageId: isEmbeed ? language_id : languageId,
        messengerType: MessengerType.Sms.code,
        bookingType: bookingType,
        sourceType: sourceType,
        ...contactInfoData,
      };

      if (promotion !== null) {
        const {
          promotionName,
          promotionPercent,
          promotionPrice,
          ...otherPromotion
        } = promotion;

        body = { ...body, ...otherPromotion };
      }

      console.group('customer -> onSubmit -> data');
      console.log('body:', body);
      console.log('contactInfoData:', contactInfoData);
      console.log('formData:', formData);
      console.groupEnd();

      doSubmit(body, collaboratorId);
    },
    [
      date,
      dateErrMsg,
      computedPricing?.distance,
      computedPricing?.price,
      dropOffData,
      errorPrice,
      errorPromotion,
      isChangedTimer,
      languageId,
      pickUpData,
      promotion,
      computedPricing?.money,
      time,
      timeErrMsg,
    ],
  );

  useEffect(() => {
    const contactNumberType = watch('contactNumberType');

    let needDialCode = contactNumberType == ContactNumberType.Zalo.code || contactNumberType == ContactNumberType.Whatsapp.code;

    if (needDialCode !== showDialCode) {
      setShowDialCode(needDialCode);
    }

  }, [watch('contactNumberType')]);

  useEffect(() => {
    checkPickUpAndDropOff(setValue, clearErrors, setError);
  }, [dropOffData, pickUpData]);

  useEffect(() => {
    computePrice(
      Number(watch('adults')), pickUpData, dropOffData, promotion
    );
  }, [watch('adults'), pickUpData, dropOffData, promotion]);

  useEffect(() => {
    if (successBooking) {

      if (bookingDone.length > 1) {
        pushToPublicHistory(router, tel ?? '');
      } else {
        pushToBookingDetail(router, bookingDone?.codeTracking);
      }
    }
  }, [successBooking]);

  return (
    <>
      <BookingContainer>
        <Container maxWidth="xl">
          <Grid container columnSpacing={2}>
            <Grid
              item
              md={12}
              lg={3.5}
              sx={{
                pt: {
                  xs: '24px',
                  sm: '84px',
                },
              }}
            >
              <AboutUs />
            </Grid>
            <Grid
              item
              md={12}
              lg={8.5}
              sx={{
                pt: {
                  xs: '24px',
                  sm: '84px',
                },
              }}
            >
              <BookingForm onSubmit={handleSubmit(onSubmit, onInvalidSubmit)} onKeyDown={e => checkKeyDown(e)}>
                <Typography component="h2">{t('common:eTaxiBooking')}</Typography>
                <Grid
                  container
                  columnSpacing={{ xs: 0, md: 3.5 }}
                  rowSpacing={{ xs: 6, md: 0 }}
                >
                  <Grid item xs={12} md={5}>
                    <BookingTripInformation>
                      <Typography component="h3">
                        {t('common:tripInfo')}
                      </Typography>
                      <Box className="wrapper-input-button">
                        <InputAutocompleteClass
                          isInitDefaultLocation={!router.query.address}
                          idText="pickUp"
                          prefixIcon={<LocationIcon />}
                          placeholder={t('common:pickUp')! + ' *'}
                          setOutput={setPickUpData}
                          setValue={(val: string, options?: any) =>
                            setValue('pickUp', val, { ...options })
                          }
                          mapValue={pickUpMapValue}
                          register={register('pickUp')}
                          error={Boolean(errors.pickUp)}
                          helperText={
                            errors.pickUp?.message &&
                            t(`validate:${errors.pickUp?.message}`)
                          }
                          icon={(
                            <IconButton onClick={() => setTypeMap('pickUp')}>
                              <MapIcon />
                            </IconButton>
                          )}
                          sxClearIcon={{ top: '35% !important' }}
                        />
                      </Box>
                      <Box className="wrapper-input-button">
                        <InputAutocompleteClass
                          idText="dropOff"
                          prefixIcon={<DirectUpIcon />}
                          placeholder={t('common:dropOff')! + ' *'}
                          setOutput={setDropOffData}
                          setValue={(val: string, options?: any) =>
                            setValue('dropOff', val, { ...options })
                          }
                          mapValue={dropOffMapValue}
                          register={register('dropOff')}
                          error={Boolean(errors.dropOff)}
                          helperText={
                            errors.dropOff?.message &&
                            t(`validate:${errors.dropOff?.message}`)
                          }
                          icon={(
                            <IconButton onClick={() => setTypeMap('dropOff')}>
                              <MapIcon />
                            </IconButton>
                          )}
                          sxClearIcon={{ top: '35% !important' }}
                        />
                      </Box>

                      <BookingNumberOfPeople>
                        <InputCustom
                          type="number"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <UserIcon />
                              </InputAdornment>
                            ),
                          }}
                          inputProps={{
                            inputMode: 'numeric',
                          }}
                          autoComplete="off"
                          placeholder={t('common:adultGreaterThan2')! + ' *'}
                          register={register('adults')}
                          error={Boolean(errors.adults)}
                          helperText={
                            errors.adults?.message &&
                            t(`validate:${errors.adults?.message}`)
                          }
                        />

                        {/* <InputCustom
                        type="number"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <UserIcon />
                            </InputAdornment>
                          ),
                        }}
                        inputProps={{
                          inputMode: 'numeric',
                        }}
                        autoComplete="off"
                        placeholder={t('common:children')!}
                        register={register('children')}
                        error={Boolean(errors.children)}
                        helperText={
                          errors.children?.message &&
                          t(`validate:${errors.children?.message}`)
                        }
                      /> */}
                      </BookingNumberOfPeople>

                      <InputCustom
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <TicketDiscountIcon />
                            </InputAdornment>
                          ),
                        }}
                        autoComplete="off"
                        placeholder={t('common:promotionCode')!}
                        register={register('promotionCode')}
                        defaultValue={promotionName}
                        disabled={promotionName !== undefined && promotionName !== null && promotionName !== ''}
                        onBlur={(event: any) => {
                          if (event.target.value.trim()) {
                            handlePromotion(event.target.value, collaboratorId);
                          } else {
                            setPromotion(null);
                            setErrorPromotion('');
                          }
                        }}
                        error={Boolean(errorPromotion)}
                        helperText={
                          !!promotion
                            ? `${t('common:discount')}: ${formatNumber(computedPricing?.discount) + ' VNĐ'}`
                            : errorPromotion ?? undefined
                        }
                      />

                      <PaymentBar
                        textKm={t('common:distance')}
                        textMoney={t('common:price')}
                        km={computedPricing?.distance}
                        money={computedPricing?.money ?? '--'}
                      />
                    </BookingTripInformation >
                  </Grid >

                  <Grid item xs={12} md={7}>
                    <BookingPersonalInformation>
                      <Typography component="h3">
                        {t('common:passengerInfo')}
                      </Typography>
                      <Box className="name-phone">
                        <InputCustom
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <UserSquareIcon />
                              </InputAdornment>
                            ),
                          }}
                          autoComplete="off"
                          placeholder={t('common:fullName')! + ' *'}
                          register={register('fullName')}
                          error={Boolean(errors.fullName)}
                          helperText={
                            errors.fullName?.message &&
                            t(`validate:${errors.fullName?.message}`)
                          }
                        />

                        <Box sx={{ display: 'flex', gap: { xs: 2, md: 1 }, flexDirection: { xs: 'column', md: 'row' } }}>
                          <BookingFormSelect
                            label={t('common:contactInformation') + ' *'}
                            options={contactNumberTypeOptions}
                            defaultValue={contactNumberTypeOptions[0].value}
                            {...register('contactNumberType')}
                            sx={{ flex: 1, }}
                          />
                          <Box sx={{
                            display: 'flex',
                            flex: {
                              xs: 1,
                              md: 2
                            },
                            marginTop: { xs: 1, md: 0 },
                          }}>
                            {
                              showDialCode ? (
                                <BookingFormSelect
                                  MenuProps={{
                                    PaperProps: {
                                      style: {
                                        maxHeight: '300px',
                                      },
                                    },
                                  }}
                                  sx={{
                                    marginRight: 1,
                                    flex: 1,
                                    maxWidth: {
                                      md: '116px',
                                      xs: '120px'
                                    }
                                  }}
                                  defaultValue="VN"
                                  label={t('common:dialCode')}
                                  {...register('dialCode')}
                                  options={dialCodes.map((e: IDialCode) => ({
                                    label: e.name,
                                    value: e.code,
                                  }))}
                                  onChange={(e: any) => {
                                    register('dialCode').onChange(e);
                                    //if (watch('phone')) {
                                    //  trigger(['phone']);
                                    //  handlePhoneNumber(
                                    //    dialCodes.find(
                                    //      (item: IDialCode) =>
                                    //        item.code === (e.target.value as string),
                                    //    )!.dialCode,
                                    //    watch('phone'),
                                    //    setValue,
                                    //    watch('fullName'),
                                    //  );
                                    //}
                                  }}
                                >
                                  {dialCodes.map((e: IDialCode, i: number) => (
                                    <MenuItem value={e.code} key={i}>
                                      {e.name}
                                    </MenuItem>
                                  ))}
                                </BookingFormSelect>
                              ) : null
                            }
                            <InputCustom
                              size="small"
                              variant="filled"
                              label={t('common:contactInformationInput')}
                              register={register('contactNumber')}
                              error={Boolean(errors.contactNumber)}
                              inputProps={{ maxLength: 20, inputMode: 'text' }}
                              helperText={errors.contactNumber?.message ? t(`validate:${errors.contactNumber?.message}`) : ' '}
                              sx={{ flex: 2, pt: '0.5rem' }}
                            />
                          </Box>
                        </Box>
                        <TextFieldCustom
                          size="small"
                          variant="filled"
                          label={
                            <Box display="flex" gap={0.5}>
                              Email
                            </Box>
                          }
                          fullWidth
                          type='email'
                          register={register('email')}
                          error={Boolean(errors.email)}
                          inputProps={{
                            maxLength: 128
                          }}
                          helperText={
                            errors.email?.message
                              ? t(`validate:${errors.email?.message}`)
                              : ' '
                          }
                        />
                      </Box>
                    </BookingPersonalInformation>

                    <BookingDateTime>
                      <Typography component="h3">{t('common:timer')}</Typography>
                      <Box className="date-time">
                        <DatePickerCustom
                          format={formatDateRequest}
                          value={date}
                          onChange={(val: any, ctx: any) => {
                            setIsChangedTimer(true);
                            setDateTimeErrMsg(ctx.validationError, 'date');
                            setDate(val);
                          }}
                          disablePast
                          helperText={dateErrMsg && t(`validate:${dateErrMsg}`)!}
                        />
                        <TimePickerCustom
                          ampm={false}
                          ampmInClock={false}
                          format={formatTimeDisplay}
                          value={time}
                          onChange={(val: any, ctx: any) => {
                            setIsChangedTimer(true);
                            setDateTimeErrMsg(ctx.validationError, 'time');
                            setTime(val);
                          }}
                          disablePast={isCurrentDate}
                          error={!!timeErrMsg}
                          //helperText={timeErrMsg && t(`validate:${timeErrMsg}`)!}
                          helperText={timeErrMsg}
                        />
                      </Box>
                      <TextField
                        autoComplete="off"
                        placeholder={t('common:description')!}
                        {...register('description')}
                        multiline
                        rows={3}
                        sx={{
                          textarea: {
                            height: '82px !important',
                          },
                          '.MuiInputBase-multiline': {
                            borderRadius: 'unset'
                          },
                          '.Mui-focused': {
                            backgroundColor: 'transparent',
                            borderBottomColor: 'primary.main',
                          },
                        }}
                      />
                    </BookingDateTime>
                  </Grid>
                  <Grid item xs={12}>
                    <ErrorSubmitBar
                      phone={tel}
                      error={Boolean(bookingErrMsg) || Boolean(errorPrice)}
                      errorText={bookingErrMsg || errorPrice}
                      buttonText={t('common:booking')}
                      sx={{ marginTop: '24px' }}
                      disabled={!isDirty || !isValid || isSubmitting}
                    />
                  </Grid>
                </Grid >
              </BookingForm >
            </Grid >
          </Grid >
        </Container >
      </BookingContainer >

      {loading && <PreLoading backgroundColor="default" />
      }

      <MapDialog
        type={typeMap}
        onClose={() => setTypeMap('')}
        setMapValue={value => {
          if (typeMap === 'pickUp') setPickUpMapValue(value);
          if (typeMap === 'dropOff') setDropOffMapValue(value);
        }}
        pickUpData={pickUpData}
        setPickUpData={data => {
          setPickUpData(data);
        }}
        dropOffData={dropOffData}
        setDropOffData={data => {
          setDropOffData(data);
        }}
      />
    </>
  );
}
